"use strict";var e=require("./components/Calendar.js"),a=require("./components/ReactCalendar/Calendar.js");exports.Calendar=e.default,exports.ReactCalendar=a.Calendar;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/cjs/index.js
// module id = 504
// module chunks = 0